/**
 * @generated SignedSource<<309f75f8f815f91f53c817c0791dca05>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type consultationOverviewQuery$variables = {
  hubName: string;
};
export type consultationOverviewQuery$data = {
  readonly hubMeta: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ConsultationOverviewFragment">;
  };
};
export type consultationOverviewQuery = {
  response: consultationOverviewQuery$data;
  variables: consultationOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v4 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "consultationOverviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ConsultationOverviewFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "consultationOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "pagination",
                    "value": {
                      "page": 0,
                      "pageSize": 100
                    }
                  }
                ],
                "concreteType": "PharmacyHubPage",
                "kind": "LinkedField",
                "name": "pharmacyHubs",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PharmacyHub",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hubId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "pharmacyHubs(pagination:{\"page\":0,\"pageSize\":100})"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "777628de1be31a70daaaa525f08135d8",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v3/*:: as any*/),
        "hubMeta.id": (v3/*:: as any*/),
        "hubMeta.name": (v4/*:: as any*/),
        "hubMeta.organization": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Organization"
        },
        "hubMeta.organization.id": (v3/*:: as any*/),
        "hubMeta.organization.pharmacyHubs": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "PharmacyHubPage"
        },
        "hubMeta.organization.pharmacyHubs.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "PharmacyHub"
        },
        "hubMeta.organization.pharmacyHubs.nodes.hubId": (v3/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.id": (v3/*:: as any*/),
        "hubMeta.organization.pharmacyHubs.nodes.phone": (v4/*:: as any*/),
        "hubMeta.organization.supportEmail": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "String"
        }
      }
    },
    "name": "consultationOverviewQuery",
    "operationKind": "query",
    "text": "query consultationOverviewQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    ...ConsultationOverviewFragment\n  }\n}\n\nfragment ConsultationOverviewFragment on HubMeta {\n  name\n  organization {\n    id\n    supportEmail\n    pharmacyHubs(pagination: {page: 0, pageSize: 100}) {\n      nodes {\n        id\n        hubId\n        phone\n      }\n    }\n  }\n  hub {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c511c2f79e09a65f4de7cb94a7334e5";

export default node;
